var exports = {
  "kL": "container__VGL_Vt",
  "vW": "inner__Rm1Enx",
  "oE": "compact__zAw66V",
  "_o": "centerAligned__GDeSlY",
};

module.exports = exports;
